import React, {PureComponent} from 'react';
import {Modal} from 'react-responsive-modal';
import MarshallWarningComponent from "./marshallWarningComponent";
import {subscribeFlagWarnings} from "../functions/api";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

class FlagModal extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            flagText: "---",
            countdown: false,
            modalOpen: false,
            flagObj: null,
            flag: null,
            showSideFlags: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {

        subscribeFlagWarnings(this.props.eventID, this.props.sessionID, false, (err, flag) => {
                this.closeModal();
                switch (flag.fty) {
                    case 'sts': {
                        let text = "";
                        let temp = <div/>;
                        // There is a countdown for flag transition
                        if (flag.tin === null && flag.tou !== null && flag.nex !== null) {
                            let nextFlagObj = this.props.convertFlags([flag.nex,])[0];
                            this.setState({
                                flagText: this.props.t("currentFlagWillTransition") + " " + nextFlagObj["desc_" + this.props.cookies.get("lang")].toUpperCase() + " " + this.props.t("in") + " ...",
                                countdown: true,
                                flagObj: nextFlagObj,
                                flagTime: flag.tou,
                                showSideFlags: true,
                                content: <div/>,
                            }, () => {
                                this.openModal();
                            });
                        }
                        // Just a normal countdown to a flag
                        else if (flag.tin !== null && flag.tou === null && flag.nex === null) {
                            let flagObj = this.props.convertFlags([flag.sts[0]])[0];
                            this.setState({
                                flagText: this.props.t("a") + " " + flagObj["desc_" + this.props.cookies.get("lang")] + " " + this.props.t("willBeActive") + " ...",
                                countdown: true,
                                flagObj: flagObj,
                                flagTime: flag.tin,
                                showSideFlags: true,
                                content: <div/>,
                            }, () => {
                                this.openModal();
                            });
                        }
                        // There is a countdown for flag clearance
                        else if (flag.tin === null && flag.nex === null && flag.tou !== null) {
                            this.setState({
                                flagText: this.props.t("flagsWillBeCleared") + " ... ",
                                countdown: true,
                                flagObj: null,
                                flagTime: flag.tou,
                                showSideFlags: false,
                                content: <div/>,
                            }, () => {
                                this.openModal();
                            });
                        }
                        // There are no countdowns, it is an instant flag
                        else if (flag.tin === null && flag.tou === null && flag.nex === null) {
                            // Sum all flag ID's. If result is zero, session was cleared and the message should be different
                            let flagIDSum = flag.sts.reduce((a, b) => {
                                return a + b;
                            });
                            if (flagIDSum > 0) {
                                let flagsObj = this.props.convertFlags(flag.sts);
                                text = this.props.t("sessionStateChanged") + "!";
                                temp = (
                                    <MarshallWarningComponent
                                        marshallPosts={this.props.marshallPosts}
                                        sendFlag={null}
                                        fullCourseFlags={null}
                                        sessionStatus={flagsObj}
                                        isSingleVehicle={false}
                                        enableClick={false}
                                        isFlagPanel={false}
                                        hasToolTip={true}
                                    />
                                );
                                this.setState({
                                    countdown: false,
                                    flagText: text,
                                    content: temp,
                                }, () => {
                                    this.openModal();
                                });
                            } else {
                                text = "---";
                                temp = (<div/>);
                            }
                        }
                        break;
                    }
                    case 'ins': {
                        if (this.props.carID === parseInt(flag.cid)) {
                            if (parseInt(flag.ins) > 0) {
                                let instructionFlag = this.props.convertFlags([parseInt(flag.ins)]);
                                let temp = [
                                    <div key={"flag_" + flag.id}
                                         className={"blink w3-animate-fading vcenter flag-shadow"}
                                         style={{backgroundImage: "url(" + serverIP + ":" + backendPort + "/images/flags/" + instructionFlag[0].src + ")", backgroundSize: "contain"}}
                                    >
                                        <img className={"organizerPanel_flagStyle"}
                                             style={{height: "100%", width: "initial"}}
                                             alt={"PIC"}
                                             src={instructionFlag[0] ? (serverIP + ":" + backendPort + "/images/flags/" + instructionFlag[0].src) : (serverIP + ":" + backendPort + "/images/flags/none_transparent.png")}
                                        />
                                    </div>
                                ];
                                this.setState({
                                    flagText: this.props.t("a") + " " + instructionFlag[0]["desc_" + this.props.cookies.get("lang")].toUpperCase() + " " + this.props.t("issuedToThisVehicle"),
                                    showSideFlags: false,
                                    countdown: false,
                                    content: temp,
                                }, () => {
                                    this.openModal();
                                });
                            }
                        }
                        break;
                    }
                    default: {
                        this.closeModal();
                        break;
                    }
                }
            }
        );
    }

    componentWillUnmount() {
        subscribeFlagWarnings(this.props.eventID, this.props.sessionID, true, null);
    }

    /* HANDLERS */
    openModal() {
        this.setState({
            modalOpen: true
        });
    }

    closeModal() {
        this.setState({
            modalOpen: false,
            countdownFlag: false,
            transitionFlag: false,
            countdown: false,
        });
    }

    /* RENDER */
    render() {
        return (
            <Modal open={this.state.modalOpen}
                   onClose={() => {
                   }}
                   animationDuration={200}
                   center={true}
                   classNames={{modal: "medium-modal fadeInLeft"}}
                   showCloseIcon={false}
            >
                <div className={"row"}>
                    <div className={"col-sm-12"}>
                        <h3 className={"text-center App_black_text"} style={{fontSize: 25}}><b>{this.state.flagText}</b></h3>
                    </div>
                    <div className={"col-xs-12 w3-animate-fading vcenter"} style={{height: "8.5vh"}}>
                        {this.state.countdown ? (
                            <CountDownFlag
                                flagObj={this.state.flagObj}
                                flagTime={this.state.flagTime}
                                closeModal={this.closeModal}
                                showSideFlags={this.state.showSideFlags}
                                t={this.props.t}
                            />
                        ) : (
                            this.state.content
                        )}
                    </div>
                    <br/>
                    <br/>
                    <div className={"col-sm-12 text-center"}>
                        <button
                            className={"btn App_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF", marginBottom: 20, marginTop: 20}}
                            onClick={this.closeModal}>{this.props.t("ok")}
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}

class CountDownFlag extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            counter: 0,
        };

        this.handleTimer = this.handleTimer.bind(this);
    }

    handleTimer() {
        const helper = this;
        clearInterval(helper.counter);
        // Avoid starting at zero
        this.setState({
            counter: this.props.flagTime,
        });

        this.counter = setInterval(() => {
            helper.setState({
                counter: helper.state.counter - 1,
            }, () => {
                if (helper.state.counter <= 0) {
                    helper.props.closeModal();
                    clearInterval(helper.counter);
                }
            });
        }, 1000);
    }

    componentDidMount() {
        this.handleTimer();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.handleTimer();
        }
    }

    render() {
        return (
            <div className={"col-xs-12 row-flex"}>
                {this.props.showSideFlags ? (
                    <div className={"col-xs-3 col-xs-offset-2 vcenter"}>
                        <div key={"session_status"} className={"App_flagContainer_dash"}>
                            <img
                                style={{marginTop: 0}}
                                className={"organizerPanel_flagStyle w3-animate-fading blink"}
                                src={(serverIP + ":" + backendPort + "/images/flags/" + this.props.flagObj.src)}
                                alt={"flag"}
                            />
                        </div>
                    </div>
                ) : (
                    <div/>
                )}
                <div className={this.props.showSideFlags ? "col-xs-2" : "col-xs-12"} style={{textAlign: "center"}}>
                    <span className={"App_title"} style={{fontSize: 80}}>{this.state.counter}</span>
                </div>
                {this.props.showSideFlags ? (
                    <div className={"col-xs-3 vcenter"}>
                        <div key={"session_status"} className={"App_flagContainer_dash"}>
                            <img
                                style={{marginTop: 0}}
                                className={"organizerPanel_flagStyle w3-animate-fading blink"}
                                src={(serverIP + ":" + backendPort + "/images/flags/" + this.props.flagObj.src)}
                                alt={"flag"}
                            />
                        </div>
                    </div>
                ) : (
                    <div/>
                )}
            </div>
        );
    }
}

export default withTranslation("translations")(withCookies(FlagModal));
